/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";
import { Link } from "react-router-dom";
import { HeaderMobile } from "./HeaderMobile";
import { HeaderDefault } from "./HeaderDefault";

export const Header: React.FC = () => {
    return (
        <>
            { (window.innerWidth <= 991) &&
                <HeaderMobile />
            }

            { (window.innerWidth > 991) &&
                <HeaderDefault />
            }
        </>

    );
}